/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect } from "react";

const PromoteKitScript: React.FC = () => {
  useEffect(() => {
    

    // Check if the script is already loaded
    const existingScript = document.querySelector("script[src='https://cdn.promotekit.com/promotekit.js']");
    

    if (!existingScript) {
      

      // Create a new script element
      const script = document.createElement("script");
      script.src = "https://cdn.promotekit.com/promotekit.js";
      

      script.async = true;
      

      // script.setAttribute("data-promotekit", "ffcd0481-870b-40aa-b8ea-13272791896d");
      script.setAttribute("data-promotekit", "845b390a-cee6-47d9-a8c1-46331b5fa3d5");
     

      // Listen for the script load event
      script.onload = () => {
        
        // You can check for the window.promotekit_refferal here if needed
        if (window.promotekit_refferal) {
          
        }
      };

      // Listen for script errors
      script.onerror = (error) => {
        console.error("Error loading PromoteKit script:", error);
      };

      // Append the script to the body
      document.body.appendChild(script);
      
    } else {
      
    }

    // Cleanup the script when the component unmounts
    return () => {
      
      const existingScript = document.querySelector("script[src='https://cdn.promotekit.com/promotekit.js']");
      // Ensure script is removed only if it's still in the document
      if (existingScript && document.body.contains(existingScript)) {
        document.body.removeChild(existingScript);
        
      } else {
        
      }
    };
  }, []);  // Empty dependency array to run the effect only once

  
  return null; // No UI rendering
};

export default PromoteKitScript;
